/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

export const AppBellContext = React.createContext(null);
